<template>
  <div class="container-fluid" v-if="transaction_details">
    <v-btn
      @click="$router.go(-1)"
      outlined
      style="border: none; margin-right: 10px; margin-top: 10px"
      class="bg-white"
      title="Retourner"
      ><v-icon>mdi mdi-arrow-left-thin</v-icon>Retour</v-btn
    >

    <v-row>
      <v-col cols="12">
        <v-alert
          type="warning"
          v-if="transaction_details._status === 'PENDING'"
        >
          Paiement en attente de finalisation
        </v-alert>
        <v-alert
          type="success"
          v-if="transaction_details._status === 'SUCCESS'"
        >
          Paiement finalisé avec succès
        </v-alert>
        <v-alert type="error" v-if="transaction_details._status === 'ERROR'">
          Erreur au cours du processus
        </v-alert>
        <v-alert type="info" v-if="transaction_details._status === 'REFUNDED'">
          Remboursement fait avec succès !
        </v-alert>
      </v-col>
    </v-row>
    <v-row
      v-if="
        transaction_details._status === 'SUCCESS' ||
        transaction_details._status === 'REFUNDED'
      "
    >
      <v-col cols="3">
        <v-card style="padding: 15px">
          <div class="row bg-white">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-credit-card-outline</v-icon>
            </div>
            <div class="col-md-12">
              <div>Source :</div>
              <div style="font-weight: bold">
                {{
                  transaction_details.mean
                    ? transaction_details.mean._name +
                      " " +
                      transaction_details.mean._country._name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card style="padding: 15px">
          <div class="row bg-white">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-cash-multiple</v-icon>
            </div>
            <div class="col-md-12">
              <div>Montant :</div>
              <div style="font-weight: bold">
                {{
                  transaction_details._amount +
                  " " +
                  transaction_details.invoice.currency
                }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card style="padding: 15px">
          <div class="row bg-white">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-clock</v-icon>
            </div>
            <div class="col-md-12">
              <div>Date :</div>
              <div style="font-weight: bold">
                {{ getDate(transaction_details._created_at) }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card style="padding: 15px">
          <div class="row bg-white">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-account-convert-outline</v-icon>
            </div>
            <div class="col-md-12">
              <div>Initiateur :</div>
              <div style="font-weight: bold">
                {{
                  transaction_details.customer
                    ? transaction_details.customer._first_name +
                      " " +
                      transaction_details.customer._last_name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card>
          <h4 style="padding: 18px; font-weight: bold" class="background-tb">
            Informations du paiement
          </h4>
          <table style="width: 100%" class="p-3 table table-striped">
            <tbody>
              <tr style="padding: 15px">
                <td style="padding: 15px">Référencement:</td>
                <td>{{ transaction_details._reference }}</td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Type de transaction_details:</td>
                <td class="text-lowercase">{{ transaction_details._type }}</td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Montant:</td>
                <td>
                  {{
                    formatAmount(transaction_details._amount) +
                    " " +
                    transaction_details.invoice.currency
                  }}
                </td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Frais de transaction_details:</td>
                <td>
                  {{
                    transaction_details._fees && transaction_details._fees > 0
                      ? formatAmount(transaction_details._fees) +
                        " " +
                        transaction_details.invoice.currency
                      : 0
                  }}
                </td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Net:</td>
                <td>
                  {{
                    transaction_details._net_amount &&
                    transaction_details._net_amount > 0
                      ? formatAmount(transaction_details._net_amount) +
                        " " +
                        transaction_details.invoice.currency
                      : "-"
                  }}
                </td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Date du paiement:</td>
                <td>{{ getDate(transaction_details._created_at) }}</td>
              </tr>
              <tr
                v-if="transaction_details._status === 'REFUNDED'"
                style="padding: 15px"
              >
                <td style="padding: 15px">Date du remboursement:</td>
                <td>{{ getDate(transaction_details._refunded_at) }}</td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Mode de paiement:</td>
                <td>
                  {{
                    transaction_details.mean &&
                    transaction_details.mean._country
                      ? transaction_details.mean._name +
                        " " +
                        transaction_details.mean._country._name
                      : "-"
                  }}
                </td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Url du paiement:</td>
                <td></td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Plate-forme:</td>
                <td></td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Périphérique:</td>
                <td>{{ limiText(transaction_details._device, 10) }}</td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <h4 style="padding: 18px; font-weight: bold" class="background-tb">
            Informations sur l’initiateur du paiement
          </h4>
          <table style="width: 100%" class="p-3 table table-striped">
            <tbody>
              <tr style="padding: 15px">
                <td style="padding: 15px">Nom & Prénom(s):</td>
                <td>
                  {{
                    transaction_details.customer
                      ? transaction_details.customer._first_name +
                        " " +
                        transaction_details.customer._last_name
                      : "-"
                  }}
                </td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">N° de téléphone:</td>
                <td>
                  {{
                    transaction_details.customer &&
                    transaction_details.customer._phone
                      ? transaction_details.customer._phone
                      : "-"
                  }}
                </td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Email:</td>
                <td>
                  {{
                    transaction_details.customer &&
                    transaction_details.customer._email
                      ? transaction_details.customer._email
                      : "-"
                  }}
                </td>
              </tr>
              <tr style="padding: 15px">
                <td style="padding: 15px">Pays de provenance:</td>
                <td v-if="transaction_details.customer">
                  <country-flag
                    v-if="transaction_details.customer.country"
                    :title="
                      transaction_details.customer._country
                        ? transaction_details.customer._country._name
                        : ''
                    "
                    :country="
                      transaction_details.customer.country
                        ? transaction_details.customer.country._code
                        : ''
                    "
                    size="normal"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="showRefundBtn && refundNotDone">
        <div class="row">
          <div class="col-md-12">
            <v-btn
              @click.prevent="refundTransaction"
              color="primary"
              outlined
              :loading="refunding"
            >
              <v-icon>mdi-autorenew</v-icon> Remboursé cette
              transaction_details</v-btn
            >
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
  <div
    v-else
    class="col-lg-12 col-md-12 col-12 text-center loader_panel_component"
  >
    <img src="/loaders/loader_turq.gif" alt="" /><br />
    <span class="loader_text"> Chargement en cours ... </span>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import * as Swal from "sweetalert2";
import helpers from "../../mixins/helpers";
import $ from "jquery";

$.fn.scrollToTop = function (speed) {
  if (typeof speed === "undefined") speed = 1000;

  $("html, body").animate(
    {
      scrollTop: parseInt($(this).offset().top),
    },
    speed
  );
};
export default {
  label: "Transactions",
  mixins: [helpers(this)],
  data() {
    return {
      refunding: false,
      refundNotDone: false,
      filter: "",
      date: new Date().toISOString().substr(0, 10),
      transactions_tabs: "",
      transaction_details: undefined,
      errors: {},
      search: "",
      dialog: "",
      id: undefined,
      headers: [
        { text: "Type", value: "_type" },
        { text: "Statut", value: "_status" },
        { text: "Source", value: "mean" },
        { text: "Référence", value: "_reference" },
        { text: "Montant", value: "_amount" },
        { text: "Frais", value: "_fees" },
        { text: "Numéro", value: "_num_source" },
        { text: "Date", value: "_created_at" },
        { text: "Action", value: "action" },
      ],
    };
  },
  computed: {
    ...mapState("payments/", ["transaction"]),
    showRefundBtn() {
      return this.transaction_details._status !== "REFUNDED";
    },
  },
  beforeMount() {
    let box = this;
    if (this.$route.params.transaction_id) {
      this.$store
        .dispatch("payments/getTransaction", this.$route.params.transaction_id)
        .then((result) => {
          box.transaction_details = result;
          console.log("transaction", result);
        });
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    getStatusColor(status) {
      let response = {};
      switch (status) {
        case process.env.VUE_APP_STATUS_ERROR:
          response.color = "red";
          response.status = "échec";
          break;
        case process.env.VUE_APP_STATUS_PENDING:
          response.color = "orange";
          response.status = "en attente";
          break;
        case process.env.VUE_APP_STATUS_SUCCESS:
          response.color = "success";
          response.status = "succès";
          break;
        default:
          response.color = "dark";
          response.status = "defaut";
          break;
      }
      return response;
    },
    refundTransaction() {
      let Self = this;
      let data = new FormData();
      data.append("transaction_id", transaction._id);
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("refund_warning"),
        confirmButtonText: this.$t("refund"),
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
      }).then((result) => {
        if (result.value) {
          Self.refunding = true;
          this.$store
            .dispatch("payments/refundTransaction", data)
            .then((response) => {
              Self.refunding = false;
              if (response.error) {
                Swal.fire({
                  icon: "error",
                  timerProgressBar: false,
                  text: response.message,
                  confirmButtonColor: "#29B3A6",
                });
              } else {
                Self.refundNotDone = true;
                Swal.fire({
                  icon: "success",
                  timerProgressBar: false,
                  text: this.$t("refund_done"),
                  confirmButtonColor: "#29B3A6",
                });
              }
            })
            .catch((error) => {
              Self.refunding = false;
              Swal.fire({
                icon: "error",
                timerProgressBar: false,
                text: this.$t("error_occured"),
              });
            });
        }
      });
    },
  },
  created() {
    this.checkisDashboard();
  },
};
</script>

<style scoped>
.bg-white {
  background-color: #fff !important;
}
.action-inputs-group {
  margin-left: 1%;
}
h2 {
  color: #1c3071;
}
.actions-inputs {
  display: inline-block;
  margin: 15px;
}
</style>
